import { boolean } from "yup";
import { PrintTab, PrintTabKey } from "./printlist.constant";

export const PrintTabs=(subject?:boolean,icard?:boolean,vacut?:boolean,cryo?:boolean,box?:boolean,dis?:boolean): PrintTab[] => [
  ...(subject ?[{
    key: "subject" as PrintTabKey,
    label: "Subject Label",
    icon: "ri-user-line",
    path: "",
  }]:[]),
  ...(icard ?[{
      key: "icard" as PrintTabKey,
      label: "Subject ICard Label",
      icon: "ri-profile-line",
      path: "icard",
    },]:[]),
    ...(vacut ?[
    {
      key: "vacutainer" as PrintTabKey,
      label: "Vacutainer Label",
      icon: "ri-flask-line",
      path: "vacutainer",
    },]:[]),
    ...(cryo ?[
    {
      key: "cryovial" as PrintTabKey,
      label: "Cryovial/Riavial Label",
      icon: "ri-test-tube-line",
      path: "cryovial",
    },]:[]),
    ...(box ?[
    {
      key: "box" as PrintTabKey,
      label: "Box Label",
      icon: "ri-archive-drawer-line",
      path: "box",
    },]:[]),
    ...(dis ?[
    {
      key: "dispensing" as PrintTabKey,
      label: "Dispensing Label",
      icon: "ri-link",
      path: "dispensing",
    },]:[])
  ];
